import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Grid from '@mui/material/Grid2'
import IconButton from '@mui/material/IconButton'
import Skeleton from '@mui/material/Skeleton'
import Typography from '@mui/material/Typography'
import { isUndefined, map } from 'lodash'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import CloseCircleIcon from '../../assets/icons/CloseCircle.svg?react'
import { BalanceForm } from '../../pages/InternalPage/FinancesPage/components/BalanceForm'
import { TariffCard } from '../../pages/InternalPage/FinancesPage/components/TariffCard'
import { TARIFF_MAP } from '../../pages/InternalPage/FinancesPage/tariff.constants'
import { useProfileStore } from '../../store/storeProfile'

export const BalanceDialog = ({ open, handleClose }) => {
    const { t } = useTranslation()
    const { userTariff, tariffList, fetchUserTariff, fetchTariffList, isLoadingFetchTariffList } =
        useProfileStore((state) => state)

    useEffect(() => {
        if (isUndefined(userTariff)) {
            fetchUserTariff()
        }
        if (isUndefined(tariffList)) {
            fetchTariffList()
        }
    }, [])

    return (
        <>
            <Dialog
                maxWidth="xl"
                fullWidth={true}
                sx={{ overflow: 'hidden' }}
                open={open}
                onClose={handleClose}>
                <DialogTitle sx={{ margin: 0 }}>
                    <Typography variant="h4">{t('finances.replenishBalance')}</Typography>
                    <Typography variant="body2" sx={{ color: '#5A5F72', pr: 4 }}>
                        {t('finances.chooseReplenishmentMethod')}
                    </Typography>
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{ position: 'absolute', right: 8, top: 8 }}>
                        <CloseCircleIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent sx={{ background: '#F9FAFB' }}>
                    <>
                        <Typography variant="h5" sx={{ textAlign: 'left', mb: 3 }}>
                            {t('finances.tariffs')}
                        </Typography>
                        <Grid
                            container
                            sx={{ justifyContent: 'space-between', alignItems: 'center' }}
                            spacing={2}>
                            {tariffList &&
                                map(tariffList, (tariff) => {
                                    return (
                                        <TariffCard
                                            key={tariff?.id}
                                            tariff={tariff}
                                            currentPrice={userTariff?.tariff?.price}
                                            isActive={userTariff?.is_active}
                                            idTariffActive={userTariff?.tariff_uuid}
                                        />
                                    )
                                })}

                            {isLoadingFetchTariffList &&
                                map(TARIFF_MAP, (_, key) => {
                                    return (
                                        <Skeleton
                                            key={key}
                                            variant="rectangular"
                                            width={356}
                                            height={436}
                                            sx={{ borderRadius: '24px', mb: 2 }}
                                        />
                                    )
                                })}
                        </Grid>
                    </>

                    <BalanceForm />
                </DialogContent>
            </Dialog>
        </>
    )
}
